const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const contactApi = {
  sendMessage: async (data: {
    name: string;
    email: string;
    message: string;
  }) => {
    const response = await fetch(`${API_BASE_URL}/api/contact-us`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || "Failed to send message");
    }

    return response.json();
  },
};
